var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"copy-to-clipboard-text",class:{ 'copied': _vm.copied, 'plain': _vm.plain},attrs:{"href":"#"},on:{"click":_vm.clicked}},[_vm._v("\n  "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"icon",class:{ 'icon-copy': !_vm.copied, 'icon-checkmark': _vm.copied}})])
}
var staticRenderFns = []

export { render, staticRenderFns }